import * as React from 'react';
import { TiptapButton } from '../TiptapButton';
import { Editor } from '@tiptap/react';
import Lift from 'Shared/icons/lift.svg';

export const IndentButton = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().sinkListItem('listItem').run()}
         isDisabled={!editor.can().sinkListItem('listItem')}
         icon={<Lift style={{ transform: 'scaleX(-1)' }} />}
         title={_js('Increase indent')}
         overrideShortcut={'tab'}
      />
   );
};
